<template>
    <v-form-item
        :rules="formRule.path"
        @error="handlerError"
        name="webhref"
        class="appid-item"
        label="网页地址"
        required="请填写"
    >
        <v-input
            v-model="hrefData.path"
            name="webhref"
            style="width:100%;"
        />
    </v-form-item>
</template>

<script>
import { VALID_REG } from '../../constants';
const defaultValue = {
    path: 'http://',
};
export default {
    props: {
        hrefVal: {
            type: Object,
            default: () => ({ ...defaultValue }),
        },
    },
    data() {
        return {
            hrefData: { ...defaultValue },
            formRule: {
                path: [
                    {
                        validate: VALID_REG.url,
                        message: '网址拼写有误，请确认后重新填写',
                        // trigger: 'blur,change', // 不要写，写了反而验证出问题。。。
                    },
                ],
            },
        };
    },
    watch: {
        hrefData: {
            handler(newVal) {
                if (newVal) this.$emit('pushMsg', newVal);
            },
            deep: true,
        },
    },
    mounted() {
        if (this.hrefVal.path !== undefined) {
            this.hrefData = { ...this.hrefVal };
        }
    },
    beforeDestroy() {
        // 组件将被卸载时，清空对应的错误。
        this.$emit('error', '');;
    },
    methods: {
        handlerError(msg) {
            this.$emit('error', msg);
        },
    },
};
</script>

<style lang="less" scoped>
</style>
